import { useState, useEffect } from 'react';

import Header from './components/header/Header';
import DataDownload from './components/data-download/DataDownload';
import UserSubscriptions from './components/user-subscriptions/UserSubscriptions.jsx';
import SqlDataTransfer from './components/sql-data-transfer/SqlDataTransfer';
import Footer from './components/footer/Footer';
import MyProfile from './components/my-profile/MyProfile';
import Login from './components/login/Login';
import Images from './components/images-page/ImagePage.jsx';
import CsvJson from './components/csv-json/CsvJson'; // adjust path as needed
import CapCode from './components/CapCode/CapCode';

import WebservicePage from './components/webservice-page/WebservicePage.jsx';

import { SubscriberDetails } from './models/SubscriberDetails';

//csv-json-info-pages
import CodesDescriptions from './components/csv-json-info-pages/used-values/CodesDescriptons'
import MileageCalculation from './components/csv-json-info-pages/used-values/MileageCalculation'
import HGVMileageCalculation from './components/csv-json-info-pages/used-values/HGVMileageCalculation'
import PublishedSequence from './components/csv-json-info-pages/used-values-live/PublishedSequence'
import TradePrices from './components/csv-json-info-pages/used-values-live/TradePrices'
import CommentLink from './components/csv-json-info-pages/used-values-live/CommentLink'
import Comments from './components/csv-json-info-pages/used-values-live/Comments'
import CodesDescriptionsFuture from './components/csv-json-info-pages/future-values/CodesDescriptionsFuture'
import FuturePrices from './components/csv-json-info-pages/future-values/FuturePrices'
import SMR from './components/csv-json-info-pages/future-values/SMR'
import PricePerMile from './components/csv-json-info-pages/future-values/PricePerMile'
import AgeMileageCalculationRules from './components/csv-json-info-pages/future-values/AgeMileageCalculationRules'
import CodeDescriptionsNVD from './components/csv-json-info-pages/new-vehicle-data/CodeDescriptionsNVD'
import NewPriceAndOptions from './components/csv-json-info-pages/new-vehicle-data/NewPriceAndOptions'
import StandardEquipment from './components/csv-json-info-pages/new-vehicle-data/StandardEquipment'
import OptionDescriptions from './components/csv-json-info-pages/new-vehicle-data/OptionDescriptions'
import TechnicalData from './components/csv-json-info-pages/new-vehicle-data/TechnicalData'
import ColourAndTrimLinks from './components/csv-json-info-pages/new-vehicle-data/ColourAndTrimLinks'
import Manufacturers from './components/csv-json-info-pages/new-vehicle-data-enhanced/Manufacturers'
import Ranges from './components/csv-json-info-pages/new-vehicle-data-enhanced/Ranges'
import Models from './components/csv-json-info-pages/new-vehicle-data-enhanced/Models'
import DerivativesAndCodes from './components/csv-json-info-pages/new-vehicle-data-enhanced/DerivativesAndCodes'
import Trims from './components/csv-json-info-pages/new-vehicle-data-enhanced/Trims'
import NVDBodyStyle from './components/csv-json-info-pages/new-vehicle-data-enhanced/NVDBodyStyle'
import BodyStyles from './components/csv-json-info-pages/new-vehicle-data-enhanced/BodyStyles'
import DriveTrains from './components/csv-json-info-pages/new-vehicle-data-enhanced/DriveTrains'
import FuelDelivery from './components/csv-json-info-pages/new-vehicle-data-enhanced/FuelDelivery'
import FuelTypes from './components/csv-json-info-pages/new-vehicle-data-enhanced/FuelTypes'
import TransmissionsTypes from './components/csv-json-info-pages/new-vehicle-data-enhanced/TransmissionsTypes'
import VehicleSectors from './components/csv-json-info-pages/new-vehicle-data-enhanced/VehicleSectors'
import ModelYears from './components/csv-json-info-pages/new-vehicle-data-enhanced/ModelYears'
import Prices from './components/csv-json-info-pages/new-vehicle-data-enhanced/Prices'
import SelectableOptions from './components/csv-json-info-pages/new-vehicle-data-enhanced/SelectableOptions'
import StandardEquipmentNVDE from './components/csv-json-info-pages/new-vehicle-data-enhanced/StandardEquipmentNVDE'
import CategoryDescriptions from './components/csv-json-info-pages/new-vehicle-data-enhanced/CategoryDescriptions'
import OptionDescriptionsNVDE from './components/csv-json-info-pages/new-vehicle-data-enhanced/OptionDescriptionsNVDE'
import PackContents from './components/csv-json-info-pages/new-vehicle-data-enhanced/PackContents'
import TechnicalDescriptions from './components/csv-json-info-pages/new-vehicle-data-enhanced/TechnicalDescriptions'
import TechnicalDataNVDE from './components/csv-json-info-pages/new-vehicle-data-enhanced/TechnicalDataNVDE'
import GenericDescriptions from './components/csv-json-info-pages/new-vehicle-data-enhanced/GenericDescriptions'
import GenericOptionLink from './components/csv-json-info-pages/new-vehicle-data-enhanced/GenericOptionLink'
import OptionToGenericCategoryLink from './components/csv-json-info-pages/new-vehicle-data-enhanced/OptionToGenericCategoryLink'
import GenericStatus from './components/csv-json-info-pages/new-vehicle-data-enhanced/GenericStatus'
import ColourAndTrimLinksNVDE from './components/csv-json-info-pages/new-vehicle-data-enhanced/ColourAndTrimLinksNVDE'
import OptionRelationships from './components/csv-json-info-pages/new-vehicle-data-enhanced/OptionRelationships'
import ColourAndHoodLinks from './components/csv-json-info-pages/new-vehicle-data-enhanced/ColourAndHoodLinks'
import Editions from './components/csv-json-info-pages/new-vehicle-data-enhanced/Editions'
import VehiclesOnRunOut from './components/csv-json-info-pages/new-vehicle-data-enhanced/VehiclesOnRunOut'
import NewVehicleDataChanges from './components/csv-json-info-pages/new-vehicle-data-enhanced/NewVehicleDataChanges'
import TechnicalDataChanges from './components/csv-json-info-pages/new-vehicle-data-enhanced/TechnicalDataChanges'
import UsedPrices from './components/csv-json-info-pages/used-values/UsedPrices';




// Sidebar.js
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';


// Sidebar icons.
import { MdOutlineFileDownload } from 'react-icons/md';
import { BsDatabase } from 'react-icons/bs';
import { FaRegFileAlt } from 'react-icons/fa';
import { WiCloud } from 'react-icons/wi';
import { IoImagesOutline } from "react-icons/io5";
import { CiUser } from 'react-icons/ci';

import './App.scss';

function App() {
  const [env, setEnv] = useState([]);
  const [userAuthenticated, setUserAuthenticated] = useState();
  const [subscriberDetails, setSubscriberDetails] = useState(new SubscriberDetails());
  const [guid, setGuid] = useState();
  const [packages, setPackages] = useState();
  const [monthlyDownloadDates, setMonthlyDownloadDates] = useState();
  const [lastLogin, setLastLogin] = useState();
  const [dataLoading, setDataLoading] = useState();

  const getEnv = () => {
    // set environment
    fetch('env.json', {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        setEnv(json);
      });
  };
  useEffect(() => {
    getEnv();
  }, []);

  function getUser(data) {
    // set state from login request
    setUserAuthenticated(data.userAuthenticated);
    setSubscriberDetails(data.subscriberDetails);
    setGuid(data.guid);
    setPackages(data.packages);
    setMonthlyDownloadDates(data.monthlyDownloadDates);
    setLastLogin(data.lastLogin);
    setDataLoading(data.dataLoading);
  }

  useEffect(() => {
    // set state from local storage
    setUserAuthenticated(localStorage.getItem('USER_AUTHENTICATED'));
    setSubscriberDetails(JSON.parse(localStorage.getItem('SUBSCRIBER_DETAILS')));
    setGuid(localStorage.getItem('GUID'));
    setPackages(JSON.parse(localStorage.getItem('PACKAGES')));
    setMonthlyDownloadDates(JSON.parse(localStorage.getItem('MONTHLY_DOWNLOAD_DATES')));
    if (localStorage.getItem('LAST_LOGIN') !== 'undefined') {
      setLastLogin(JSON.parse(localStorage.getItem('LAST_LOGIN')));
    }
  }, []);

  const HorizontalLine = () => (
    <hr className="seperator-line" />
  );
  const TopHorizontalLine = () => (
    <hr className="top-seperator-line" />
  );

  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header
          env={env}
          userAuthenticated={userAuthenticated}
          subscriberDetails={subscriberDetails}
          lastLogin={lastLogin}
          dataLoading={dataLoading}
        />
        <div className="app-container" style={{ display: 'flex' }}>
          <span>
            {userAuthenticated ? <div className="side-menu">
              <nav>
                <ul>
                  <TopHorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/DataDownload">
                    <span className='menu-icon'>
                      <MdOutlineFileDownload className='product-download-icon' />
                    </span> Data Download</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link to="/UserSubscriptions">
                    <span className='menu-icon'>
                      <CiUser className='product-download-icon' />
                    </span> Subscriptions</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/SqlDataTransfer">
                    <span className='menu-icon'>
                      <BsDatabase className='product-download-icon' />
                    </span> SQL Data Transfer</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/CsvJson">
                    <span className='menu-icon'>
                      <FaRegFileAlt className='product-download-icon' />
                    </span> CSV and JSON</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/WebservicePage">
                    <span className='menu-icon'>
                      <WiCloud className='product-download-icon bigger-icon' />
                    </span>&nbsp; Web Services</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/CapCode">
                    <span className='menu-icon'>
                      <FaRegFileAlt className='product-download-icon' />
                    </span> CAPCodes</Link></li>
                  <HorizontalLine />
                  <li className='menu-text'><Link className="no-underline" to="/Images">
                    <span className='menu-icon'>
                      <IoImagesOutline className='product-download-icon' />
                    </span> Images </Link></li>
                  <HorizontalLine />
                </ul>
              </nav>
            </div> : null}

          </span>
          <div style={{ flex: 1, padding: '20px' }}>
            <Routes>
              <Route
                path="/login"
                element={<Login env={env} user={getUser} />}
              />
              <Route
                path="/home"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <DataDownload env={env} dataLoading={dataLoading} />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/myProfile"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <MyProfile subscriberDetails={subscriberDetails} />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="*"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Navigate to="/home" />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CsvJson />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/WebservicePage"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <WebservicePage />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/dataDownload"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <DataDownload />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/UserSubscriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <UserSubscriptions env={env} subscriberDetails={subscriberDetails} />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-codes-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CodesDescriptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-used-prices"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <UsedPrices />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-mileage-calculation"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <MileageCalculation />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-HGV-mileage-calculation-rules"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <HGVMileageCalculation />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-live-published-sequence"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <PublishedSequence />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-live-trade-prices"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TradePrices />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-live-comment-link"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CommentLink />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/used-values-live-comments"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Comments />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/future-values-codes-and-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CodesDescriptionsFuture />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/future-values-future-prices"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <FuturePrices />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/future-values-smr"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <SMR />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/future-values-price-per-mile"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <PricePerMile />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/future-values-age-mileage-calculation-rules"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <AgeMileageCalculationRules />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-code-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CodeDescriptionsNVD />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-new-price-options"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <NewPriceAndOptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-standard=equipment"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <StandardEquipment />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-option-description"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <OptionDescriptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-technical-data"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TechnicalData />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-colour-and-trim-links"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <ColourAndTrimLinks />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-manufacturers"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Manufacturers />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-ranges"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Ranges />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-models"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Models />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-derivatives-and-codes"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <DerivativesAndCodes />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-trims"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Trims />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-NVD-body-style"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <NVDBodyStyle />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-body-style"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <BodyStyles />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-drive-trains"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <DriveTrains />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-fuel-delivery"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <FuelDelivery />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-fuel-types"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <FuelTypes />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-transmissions-types"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TransmissionsTypes />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-vehicle-sectors"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <VehicleSectors />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-model-years"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <ModelYears />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-prices"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Prices />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-selectable-options"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <SelectableOptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-standard-equipment"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <StandardEquipmentNVDE />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-category-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CategoryDescriptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-option-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <OptionDescriptionsNVDE />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-pack-contents"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <PackContents />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-technical-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TechnicalDescriptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-technical-data"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TechnicalDataNVDE />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-generic-descriptions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <GenericDescriptions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-generic-option-link"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <GenericOptionLink />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-option-to-generic-category-link"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <OptionToGenericCategoryLink />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-generic-status"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <GenericStatus />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-colour-and-trim-links"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <ColourAndTrimLinksNVDE />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-colour-and-hood-links"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <ColourAndHoodLinks />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-option-relationships"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <OptionRelationships />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-editions"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Editions />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-vehicles-on-run-out"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <VehiclesOnRunOut />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/CsvJson/new-vehicle-data-enhanced-new-vehicle-data-changes"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <NewVehicleDataChanges />
                    : <Navigate to="/login" />
                }
              />

              <Route
                path="/CsvJson/new-vehicle-data-enhanced-technical-data-changes"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <TechnicalDataChanges />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/SqlDataTransfer"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <SqlDataTransfer env={env}/>
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/Images"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <Images />
                    : <Navigate to="/login" />
                }
              />
               <Route
                path="/CapCode"
                element={
                  localStorage.getItem('USER_AUTHENTICATED') === 'true'
                    ? <CapCode />
                    : <Navigate to="/login" />
                }
              />          
            </Routes>
          </div>
        </div>
        {!dataLoading && <Footer text={userAuthenticated} />}
      </div>
    </Router>
  );
}

export default App;